export default {
  data: () => ({
    Gas: {
      key: 'GAS',
      value: 'Benzyna'
    },
    Diesel: {
      key: 'DIESEL',
      value: 'Diesel'
    },
    GasLpg: {
      key: 'GAS_LPG',
      value: 'Benzyna + LPG'
    },
    Hybrid: {
      key: 'HYBRID',
      value: 'Hybryda'
    },
    Electric: {
      key: 'ELECTRIC',
      value: 'Elektryczny'
    },
  }),
  methods: {
    getFuelTypes() {
      return [this.Gas, this.Diesel, this.GasLpg, this.Hybrid, this.Electric]
    },
    getFuelTypeLabel(value) {
      return this.getFuelTypes().find((tc) => tc.key === value).value
    },
  }
}
